var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-wrapper", class: _vm.theme },
    [
      _c("j-language-menu", {
        ref: "languageMenu",
        attrs: { size: "default" }
      }),
      _c("header-notice", { ref: "headerNotice", staticClass: "action" }),
      _c(
        "a-dropdown",
        [
          _c(
            "span",
            {
              staticClass:
                "action action-full ant-dropdown-link user-dropdown-menu"
            },
            [
              _c("a-avatar", {
                staticClass: "avatar",
                attrs: { size: "small", src: _vm.getAvatar() }
              }),
              _vm.isDesktop()
                ? _c("span", [
                    _vm._v(
                      _vm._s(this.$store.getters.language["home.welcome"]) +
                        _vm._s(_vm.nickname())
                    )
                  ])
                : _vm._e()
            ],
            1
          ),
          _c(
            "a-menu",
            {
              staticClass: "user-dropdown-menu-wrapper",
              attrs: { slot: "overlay" },
              slot: "overlay"
            },
            [
              _c(
                "a-menu-item",
                { key: "4", on: { click: _vm.updatePassword } },
                [
                  _c("a-icon", { attrs: { type: "setting" } }),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        this.$store.getters.language["home.changePassword"]
                      )
                    )
                  ])
                ],
                1
              ),
              _c(
                "a-menu-item",
                { key: "5", on: { click: _vm.updatePersonalInfo } },
                [
                  _c("a-icon", { attrs: { type: "setting" } }),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        this.$store.getters.language["portal.front.sso.update"]
                      )
                    )
                  ])
                ],
                1
              ),
              _c(
                "a-menu-item",
                { key: "6", on: { click: _vm.handleLogout } },
                [
                  _c("a-icon", { attrs: { type: "logout" } }),
                  _c("span", [
                    _vm._v(_vm._s(this.$store.getters.language["home.signOut"]))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("user-password", { ref: "userPassword" }),
      _c("depart-select", {
        ref: "departSelect",
        attrs: { closable: true, title: "部门切换" }
      }),
      _c("setting-drawer", {
        ref: "settingDrawer",
        attrs: { closable: true, title: "系统设置" }
      }),
      _c("update-user-info-modal", { ref: "personalInfo" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }